import styled from "styled-components";

const bannerMargin = ($inContent?: boolean, $wide?: boolean) => {
  if ($wide) return "0 0 24px";
  return $inContent ? "0 100px 24px" : "16px 75px";
};

export const Banner = styled.div<{ $inContent?: boolean; $wide?: boolean }>`
  box-sizing: border-box;
  margin: ${({ $inContent, $wide }) => bannerMargin($inContent, $wide)};
  padding: 10px 24px;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #363636;
  border-radius: 10px;
  font-family: "Poppins", sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    margin: 12px 16px;
    padding: 10px 16px;
    min-height: 0;
    font-size: 14px;
  }
`;

export const Strong = styled.span`
  font-weight: 700;
`;
